var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalanderGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11458_108258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 1.66992V5.00326M13.334 1.66992V5.00326M10.0007 12.5033H13.334M3.33398 9.16992H16.6673M6.66732 12.5033H6.75065M5.00065 16.6699H15.0007C15.9211 16.6699 16.6673 15.9237 16.6673 15.0033V5.00326C16.6673 4.08278 15.9211 3.33659 15.0007 3.33659H5.00065C4.08018 3.33659 3.33398 4.08278 3.33398 5.00326V15.0033C3.33398 15.9237 4.08018 16.6699 5.00065 16.6699Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11458_108258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.00292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalanderGray);
export default __webpack_public_path__ + "static/media/calanderGray.b87048f301c82d34869747af9a142ae9.svg";
export { ForwardRef as ReactComponent };